// TES-1277 (TES-1266, Emelie 2026-10-12) — "Coachens och patientens namn ska
// visas med inledande versal och resterande bokstäver gemena. Hårdkodade
// versala namn som EMELIE eller MAJA får inte förekomma."
//
// Ported from the app's `formatPersonName` (apps/mobile/src/auth/person-name.ts)
// so the API and the app can share one rule. One difference, on purpose: the
// app's copy leaves a name that already contains a lowercase letter alone,
// because it only had to fix the registry's ALL CAPS. Staff display names are
// free text typed into admin, so "emelie" or "eMELIE" are as possible as
// "EMELIE", and the canon asks for one casing whatever came in. Every word
// gets an initial capital and the rest lowercase.
//
// Capitalisation restarts after spaces, hyphens and both apostrophe forms
// (ANNA-KARIN → Anna-Karin, O'BRIEN → O'Brien). Plain toUpperCase/toLowerCase
// handle accented letters via Unicode default casing; no Intl (Hermes-safe).
export function formatPersonName(raw: string): string {
  return raw
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase()
    .split(/([ \-'’])/)
    .map((part) => (part ? part.charAt(0).toUpperCase() + part.slice(1) : part))
    .join("");
}

/** The first word of a formatted name ("Anna-Karin Svensson" → "Anna-Karin"). */
export function personFirstName(raw: string): string {
  return formatPersonName(raw).split(" ")[0] ?? "";
}
